import type { TStore } from "~/app/pages/Store/types/TStore";
import { requestApi } from "~/app/services/api/requestApi";

export async function getPWAReward() {
  const result: TStore = await requestApi({
    endpoint: "store",
    method: "get",
  });

  const data = result.Data.Store.StoreFronts.WebSpecialOffers.StoreFront.Listings.find(
    (k) => k.Name === "PWA_Reward",
  );
  const purchaseCount = Object.entries<number>(
    result.Data.PurchaseCounts.UserStoreListingPurchaseCounts,
  ).find((k) => k[0] === "PWA_Reward");
  const isPWARewardClaimed = Array.isArray(purchaseCount) && purchaseCount[1] > 0;

  return {
    isPWARewardClaimed,
    storeListing: data ? data?.StoreListing : null,
  };
}
